

import Tether from 'tether';
import Debug from 'debug';
import jQuery from 'jquery';

const debug = Debug('gh:lobuilder:util');

jQuery(() => {
  let parentTeather = null;

  jQuery('.js--fixed-to-body-bottom').each((index, val) => {
    if ((index % 2)) $(val).css('visibility', 'hidden'); // Simple way to mean the button doesn't overlap the content at the bottom, but if you have two then you only want white space for one
    else $(val).css('display', 'none');

    const clonedElement = $(val).clone();
    clonedElement.removeAttr('style');
    clonedElement.addClass('gh--fixed-to-body-bottom');

    if (parentTeather !== null) {
      parentTeather.addClass('gh--fixed-to-body-bottom--has-nested');
      $(parentTeather).append(clonedElement.html());
    } else {
      $('body').append(clonedElement);
      parentTeather = clonedElement;
      debug('Attaching a element to the bottom of the body', val);
      jQuery(document).ready(function () {
        new Tether({
          element: clonedElement,
          target: 'body',
          attachment: 'bottom middle',
          targetAttachment: 'bottom middle',
        });
      });
    }
  });
});




// WEBPACK FOOTER //
// Glasshouse/Core/js/utils.js